var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadSmIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 160,
    viewBox: "0 0 160 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M63.7134 39.9666C79.3291 39.9666 92.8414 48.9725 99.3345 62.074L99.5581 62.5251L100.007 62.2986C102.153 61.217 104.577 60.6072 107.146 60.6072C115.914 60.6072 123.022 67.7127 123.022 76.4773C123.022 76.5915 123.021 76.7063 123.018 76.822L123.007 77.3328H128.329C139.948 77.3328 149.367 86.7487 149.367 98.363C149.367 109.977 139.948 119.393 128.329 119.393H31.1382C19.519 119.393 10.1001 109.977 10.1001 98.363C10.1002 89.3717 15.7454 81.6965 23.688 78.6892L23.9985 78.572L24.0103 78.24C24.7684 56.9743 42.2539 39.9666 63.7134 39.9666Z",
    stroke: "url(#paint0_linear_278_24118)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M86.21 104.508C86.7006 104.508 87.0986 104.906 87.0986 105.396C87.0986 105.887 86.7007 106.285 86.21 106.285H73.7646C73.2739 106.285 72.876 105.887 72.876 105.396C72.8761 104.906 73.274 104.508 73.7646 104.508H86.21ZM86.0986 99.1746C86.6508 99.1747 87.0986 99.6223 87.0986 100.175V101.729C87.0986 102.281 86.6508 102.729 86.0986 102.729H73.876C73.3238 102.729 72.876 102.281 72.876 101.729V100.175C72.876 99.6224 73.3238 99.1747 73.876 99.1746H86.0986ZM86.0986 92.0632C86.6508 92.0633 87.0986 92.511 87.0986 93.0632V96.3962C87.0986 96.9485 86.6508 97.3961 86.0986 97.3962H73.876C73.3238 97.3961 72.876 96.9484 72.876 96.3962V93.0632C72.876 92.511 73.3238 92.0634 73.876 92.0632H86.0986ZM79.2803 69.6589C79.6708 69.2685 80.3038 69.2686 80.6943 69.6589L95.1338 84.0984C95.4488 84.4134 95.2257 84.9519 94.7803 84.9519H87.0986V89.2849C87.0986 89.8371 86.6508 90.2848 86.0986 90.2849H73.876C73.3238 90.2848 72.876 89.8371 72.876 89.2849V84.9519H65.1943C64.749 84.9518 64.5259 84.4133 64.8408 84.0984L79.2803 69.6589Z",
    fill: "url(#paint1_linear_278_24118)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_278_24118",
    x1: 79.7335,
    y1: 39.4666,
    x2: 79.7335,
    y2: 119.893,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B59AF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#71F6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_278_24118",
    x1: 79.9873,
    y1: 83.8674,
    x2: 79.9873,
    y2: 106.285,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7DDFBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7DDFBB",
    stopOpacity: 0.4
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadSmIcon);
export default __webpack_public_path__ + "static/media/upload-sm-Icon.2b6298060563ab94bbdaa2a1f57023d6.svg";
export { ForwardRef as ReactComponent };